import { Box, Stack } from "@mui/material";
import { TextInput, NumberInput, SelectInput, BooleanInput, required } from "react-admin";
import { FormSection } from "@/components/common/inputs/FormSection";
import { getInputProps } from "@/utils/helpers/columnsHelper";
import { ResourceName } from "@/types";

const getTemplateInputProps = (key: string, textReplace = {}) =>
  getInputProps(key, textReplace, ResourceName.TASK_TEMPLATES);

const triggerEventChoices = [
  { id: "threshold_50_percent", name: "Threshold 50%" },
  { id: "threshold_85_percent", name: "Threshold 85%" },
  { id: "threshold_100_percent", name: "Threshold 100%" },
  { id: "icd_trigger_detected", name: "ICD Trigger Detected" },
  { id: "placeholder_client_created", name: "Client Created" },
  { id: "placeholder_policy_created", name: "Policy Created" },
  { id: "stoploss_claim_update", name: "Stop-Loss Claim Update" },
  { id: "prompt_pay_required", name: "Prompt Pay Required" },
];

const recordSubjectChoices = [
  { id: "claimant", name: "Claimant" },
  { id: "client", name: "Client" },
  { id: "policy", name: "Policy" },
  { id: "stoploss_claim", name: "Stop-Loss Claim" },
  { id: "reimbursement", name: "Reimbursement" },
];

const templateCategoryChoices = [
  { id: "threshold_monitoring", name: "Threshold Monitoring" },
  { id: "data_quality", name: "Data Quality" },
];

export const TaskTemplateCreateInputs = () => {
  return (
    <Box p={2}>
      <TextInput {...getTemplateInputProps("title")} validate={required()} fullWidth size="small" />

      <TextInput {...getTemplateInputProps("description")} fullWidth multiline rows={3} size="small" />

      <BooleanInput source="is_active" label="Active" defaultValue={true} size="small" />

      <FormSection title="Trigger Configuration">
        <Stack direction="row" spacing={1}>
          <SelectInput
            {...getTemplateInputProps("trigger_event")}
            choices={triggerEventChoices}
            size="small"
            fullWidth
          />
          <SelectInput
            {...getTemplateInputProps("record_subject")}
            choices={recordSubjectChoices}
            size="small"
            fullWidth
          />
        </Stack>
        <SelectInput
          {...getTemplateInputProps("template_category")}
          choices={templateCategoryChoices}
          size="small"
          fullWidth
        />
      </FormSection>

      <FormSection title="Task Defaults">
        <Stack direction="row" spacing={1}>
          <NumberInput {...getTemplateInputProps("priority")} size="small" min={0} helperText="1 = highest" />
          <NumberInput
            {...getTemplateInputProps("default_due_days")}
            size="small"
            min={1}
            helperText="Days until task is due"
          />
        </Stack>
        <BooleanInput
          {...getTemplateInputProps("default_show_on_claim_exhibit")}
          size="small"
          helperText="Include on claim exhibit"
        />
      </FormSection>
    </Box>
  );
};
